import MobileHomeAccount from './MobileHomeAccount';

export default MobileHomeAccount;
